import React, { forwardRef, useContext } from 'react';
import proptypes from 'prop-types';

const { arrayOf, bool, func, number, shape, string } = proptypes;
import { AddTo } from '@thd-olt-component-react/add-to';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ProductListContext } from '../ProductListContext';
import { CopyToButton } from './CopyToButton';

export const AddToMobile = forwardRef(({
  addToProducts,
  addToListProducts,
  handleAddToClick,
  needToLoadProducts,
  noSelectedItems,
  noListSelectedItems,
  updateLoadedProductsData,
  isStickyBar,
  copyToMobileButtonStyles
}, ref) => {

  const { productsDisplayed } = useContext(ProductListContext);
  const { isB2BCustomer = false } = useThdCustomer();

  // Non-B2B customers: Copy To shows List only (no Project/Quote options)
  if (!isB2BCustomer) {
    return (
      <AddTo
        addToType="List"
        products={addToListProducts}
        CustomAddToActionElement={({ onClick }) => (
          <CopyToButton
            onClick={onClick}
            disabled={noListSelectedItems}
            isStickyBar={isStickyBar}
            className={copyToMobileButtonStyles}
            showIcon={!isStickyBar}
          />
        )}
      />
    );
  }

  // B2B customers: Copy To shows selection screen (List/Project/Quote)
  return (
    <div ref={ref} className="sui-w-full">{
      (needToLoadProducts)
        ? (
          <CopyToButton
            onClick={(onClick) => handleAddToClick(onClick, '...')}
            isStickyBar={isStickyBar}
            className={copyToMobileButtonStyles}
            showIcon={!isStickyBar}
          />
        )
        : (
          <AddTo
            addToFallbackType={null}
            addToType={null}
            loadedProductsData={productsDisplayed}
            showSelectionScreen
            products={addToProducts}
            updateLoadedProductsData={updateLoadedProductsData}
            CustomAddToActionElement={({ onClick }) => (
              <CopyToButton
                onClick={onClick}
                disabled={noSelectedItems}
                className={copyToMobileButtonStyles}
                showIcon={!isStickyBar}
              />
            )}
          />
        )
    }
    </div>
  );
});

AddToMobile.propTypes = {
  addToProducts: arrayOf(shape(
    {
      itemId: string.isRequired,
      price: string,
      productData: shape({
        info: shape({}),
        identifiers: shape({}),
        pricing: shape({})
      }),
      quantity: number,
      sku: shape({
        storeSkuNumber: string,
        omsThdSku: string,
        specialOrderSku: string
      })
    }
  )).isRequired,
  addToListProducts: arrayOf(shape(
    {
      itemId: string,
      intent: string,
      quantity: number
    }
  )),
  handleAddToClick: func.isRequired,
  needToLoadProducts: bool.isRequired,
  noSelectedItems: bool.isRequired,
  noListSelectedItems: bool,
  updateLoadedProductsData: func,
  isStickyBar: bool,
  copyToMobileButtonStyles: string
};

AddToMobile.defaultProps = {
  addToListProducts: [],
  noListSelectedItems: true,
  updateLoadedProductsData: () => {},
  isStickyBar: false,
  copyToMobileButtonStyles: ''
};